import React from "react";

const ReturnPara = () => {
  return (
    <div className="returnParaContainer">
      <ul>
        <li>We do not offer refunds or exchanges for opened products.</li>
        <li>
          However, if you are not satisfied with a product(s) and notify us
          within 48 hours of receiving the product(s), we will assist you on a
          case-by-case basis.
        </li>
        <li>
          Claims for damages or expired products must be reported to customer
          service within 48 hours of receiving the product.
        </li>
        <li>
          Once a return claim is accepted, it will be processed within 72 hours.
          Depending on the mode of payment used, banks and payment gateways may
          take up to 7-12 working days to credit the amount to your account.
        </li>
        <li>
          No returns or refunds will be accepted for products purchased under
          any promotions, discount vouchers, or during any promotional sale
          period.
        </li>
        <li>
          Products returned without original packaging, price tags, seals, and
          labels will not be accepted, and no refunds will be issued.
        </li>
        <li>
          For further questions regarding returns and refunds, please reach out
          to us at <a href="mailto:info@scentlifestyle.com">info@scentlifestyle.com</a>
        </li>
      </ul>
    </div>
  );
};

export default ReturnPara;
